// extracted by mini-css-extract-plugin
export var container = "_rd-0";
export var dotAnimation = "_rd-2";
export var dotsLoading = "_rd-1";